import Control from 'ol/control/Control'

import { setBlurredButton } from './mapLayers'
import { getLayerById, map } from '../map/tools'
import { debug, maxEditResolution } from '../storage'

// Legend button.
export class LegendControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    if (options.id) { button.id = options.id; }
    button.title = 'Tegnforklaring';
    button.innerHTML = '<i class="material-icons">format_list_bulleted</i>';
    // button.innerHTML = '<i class="material-icons">list</i>';

    const element = document.createElement('div');
    element.className = 'legend-btn ol-unselectable ol-control';
    element.appendChild(button);
    const legend = document.getElementById('legend');
    if (options.position) {
      const p = options.position;
      element.style.bottom = p + 'px';
      legend.classList.add('t' + p);
    }

    super({ element: element, target: options.target });

    button.addEventListener('click', this.toggleLegend.bind(this));
    button.addEventListener('blur', this.hideLegend.bind(this));
    // Focus back on button after having used a slider:
    legend.onmouseup = () => button.focus();
    document.getElementById('map').onmouseup = () => {
      const hovering = (c) => {
        return document.getElementsByClassName(c)[0].matches(':hover');
      };
      if (legend.classList.contains('closed')) return;
      if (!hovering('layers-button') && !hovering('base-maps')) button.focus();
    };
  }

  toggleLegend = (e) => {
    const legend = document.getElementById('legend');
    // console.log('click legend');
    legend.classList.toggle('closed');
  };
  hideLegend = (e) => {
    // console.log('save blurring to be able to focus again');
    setBlurredButton(e.target);
    const legend = document.getElementById('legend');
    if (legend.matches(':hover')) return;
    if (document.getElementById('map').matches(':hover')) {
      const hovering = (c) => {
        return document.getElementsByClassName(c)[0].matches(':hover');
      };
      if (!hovering('layers-button') && !hovering('base-maps')) return;
    }
    legend.classList.add('closed');
  };
}

const withinResolutionLimits = (layer) => {
  const current = map.getView().getResolution();
  const min = layer.getMinResolution();
  const max = layer.getMaxResolution();
  return (min <= current && current <= max);
};

const updateLegend_ = () => { // according to flybilder, zoom level and 13 on/off
  if (debug < 12) console.log('Update legend!');
  const k13 = getLayerById('ar5_13WMS');
  let up = true; // update from 7 to 13 (true) or viceversa (false)
  // At Postgis zoom level, it has always to be ar5 7 klasser:
  const postgis = (map.getView().getResolution() < maxEditResolution);
  // Double legend:
  const legend = document.getElementById('legend');
  if (postgis && k13 && k13.getVisible()) legend.classList.add('with13');
  else legend.classList.remove('with13');
  const off13 = (!k13 || !k13.getVisible() || postgis);
  if (document.getElementById('legendHeader').innerHTML === 'Arealtype') {
    if (off13) return; // no need to update legend
    // else up = true; // update legend from 7 to 13
  } else { // legend is currently set on 13 klasser
    if (off13) up = false; // update legend from 13 to 7
    else return; // no need to update legend
  }
  // console.log('If you arrived her, legend needs to be updated');
  const title = up ? 'Markslag 13 klasser' : 'Arealtype';
  document.getElementById('legendHeader').innerHTML = title;
  document.getElementById('legendImg').src = '' +
    `https://wms.nibio.no/cgi-bin/${up ? 'ar5gpi' : 'ar5'}` +
    '?version=1.1.1&service=WMS&request=GetLegendGraphic&' +
    `format=image/png&layer=${up ? 'GPI13klasser_fill' : 'Arealtype'}`
  ;
  // legend.style.maxWidth = up ? '225px' : '170px'; // ruins transition
  if (up) legend.classList.add('single13');
  else legend.classList.remove('single13');
};

// Update legend according to flybilder, zoom level and 13 on/off:
export const updateLegend = () => {
  if (debug < 11) console.log('Update legend!');
  const k11 = getLayerById('arealtypeWMS');
  const visible11 = (k11 && k11.getVisible() && withinResolutionLimits(k11));
  document.getElementById('hidable11').hidden = (visible11) ? false : true;
  const k13 = getLayerById('ar5_13WMS');
  const visible13 = (k13 && k13.getVisible() && withinResolutionLimits(k13));
  document.getElementById('hidable13').hidden = (visible13) ? false : true;
  if (visible11) legend.classList.add('with11');
  else legend.classList.remove('with11');
  if (visible13) legend.classList.add('with13');
  else legend.classList.remove('with13');
  const td2 = document.getElementById('ar5_bakgrunn');
  td2.style.display = (visible11 && visible13) ? 'grid' : 'table-cell';
  if (visible11 && visible13) td2.classList.add('both_11_13');
  else td2.classList.remove('both_11_13');
  const postgis = (map.getView().getResolution() < maxEditResolution);
  document.getElementById('ar5_original').hidden = postgis ? false : true;
  const hide = (!postgis && !visible11 && !visible13);
  if (hide) document.getElementById('legend').classList.add('closed');
  const btn = document.getElementsByClassName('legend-btn')[0];
  if (btn) btn.hidden = hide ? true : false;
};

export const reflectInput = (to, i) => {
  const target = document.getElementById(to);
  target.value = i;
  target.dispatchEvent(new Event('input'));
};

